import { ActionType } from '@/models/enum-types/action-type.enum'
import DeviceViewData from '@/models/modelView/IDeviceView'
import IDeviceStore from '@/models/modelStore/IDeviceStore'
import { ModemStrategy } from '@/strategies/modem.strategy/modem.strategy'
import IPosition from '@/models/dto/position.dto'
import CommandsService from '@/api/services/commands.service'
import IDataInfo from '@/models/modelView/IDataInfo'
import DeviceUtil from '@/utils/device.util'

export default class At6Strategy extends ModemStrategy {
    getExtraAttributes(attributes: any): IDataInfo[] {
        return [{ title: 'Odo:', value: (attributes.totalDistance / 1000).toFixed(2) + 'Km' }]
    }
    getReportDetails(data: IPosition[], device: IDeviceStore) {
        const virtualOdometer = device?.attributes?.services?.find((item) => item.name == 'virtual_odometer')?.value
        if (virtualOdometer) {
            return this.genericReportDetails(data, device)
        } else {
            return null
        }
    }

    customAttributes: any[] = [{ name: 'sat', viewName: 'Satélites:', suffix: '', precision: 0 }]

    async sendCommand(deviceId: number, type: ActionType, data?: string) {
        let command = ''
        switch (type) {
            case ActionType.RESET:
                command = 'RESET#'
                break
            default:
                break
        }
        await CommandsService.sendCommand(command, deviceId)
    }
    mapDevice(device: IDeviceStore): DeviceViewData {
        return {
            data_icons: this.mapIcons(device),
            data_info: this.mapAttributes(device.position?.attributes, device),
            icon: device.icon || '0',
            id: device.id,
            plate: device.name,
            time: device.position?.deviceTime || device.position?.serverTime || device.position?.fixTime || '',
            speed: DeviceUtil.formatKnToKmh(device.position?.speed),
        }
    }

    mapIcons(device: IDeviceStore) {
        const attributes = device?.position?.attributes
        const array = []
        if (attributes?.ignition) {
            array.push({
                classes: ['icon-data', 'key-green'],
                src: require('@/assets/img/key-green.svg'),
                extra: '',
            })
        } else {
            array.push({
                classes: ['icon-data', 'key-red'],
                src: require('@/assets/img/key-red.svg'),
                extra: '',
            })
        }

        if (device.position?.attributes?.charge)
            array.push({
                classes: ['icon-data', 'charge'],
                src: require('@/assets/img/charge.svg'),
                extra: '',
            })

        if (device.position?.attributes?.battery) {
            array.push({
                classes: ['icon-data', 'battery-gps'],
                src: require('@/assets/img/battery-gps.svg'),
                extra: (this.getBatteryPercentage(device.position?.attributes?.battery) || '-') + '%',
            })
        }

        return array
    }

    getBatteryPercentage(voltage: number): number {
        if (voltage >= 4.13) return 100
        if (voltage >= 4.08) return 90
        if (voltage >= 4.0) return 80
        if (voltage >= 3.91) return 70
        if (voltage >= 3.87) return 60
        if (voltage >= 3.81) return 50
        if (voltage >= 3.78) return 40
        if (voltage >= 3.75) return 30
        if (voltage >= 3.73) return 20
        if (voltage >= 3.7) return 10
        if (voltage >= 3.6) return 5
        return 0
    }
}
